import AreaCard from "./AreaCard";
import "./AreaCards.scss";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import API from "../../api/axiosInstance";

const AreaCards = () => {
  const [userCount, setUserCount] = useState(0);
  const [codeCount, setCodeCount] = useState(0);
  const [fileCount, setFileCount] = useState(0);
  const [folderCount, setFolderCount] = useState(0);
  const [folderSubCount, setFolderSubCount] = useState(0);
  const { t } = useTranslation();

  const [soldCode, setSoldCode] = useState([]); 
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    API
      .get(`code`, {
        params: {
          reseller: user.id,
          limit:10000
        }
      })
      .then((response) => {
        console.log(response.data);
        
        const numberOfCodes = response.data.totalCount;
        const numberOfSoldCodes = response.data.data;

        let soldCodeCount = 0;
        numberOfSoldCodes.forEach((item) => {
          if (item.soldAt) {
            // Check if soldDate exists
            soldCodeCount++;
          }
        });

        setSoldCode(soldCodeCount);
        setCodeCount(numberOfCodes);
      })
      .catch((error) => {
        console.error("Error fetching code data:", error);
      });
  }, []);

  return (
    <section className="content-area-cards">
      <AreaCard
        colors={["#e4e8ef", "#4ce13f"]}
        percentFillValue={codeCount}
        cardInfo={{
          title: t("TotalCodes"),
          value: codeCount,
          text: `${t("TotalCodeDec")}: ${soldCode}`,
        }}
      />
    </section>
  );
};

export default AreaCards;
